import 'css-chunksrc/feature/check/CheckVoids.module.scss';export default {
  "root": "CheckVoids_root"
};